export default function PresignBlobsFactory(
  calculateChecksum,
  presignBlobsMutation,
) {
  return async (files) => {
    const filesInput = await Promise.all(
      files.map(async (file) => ({
        checksum: await calculateChecksum(file),
        filename: file.name,
        contentType: file.type,
        byteSize: file.size,
      })),
    );

    return presignBlobsMutation(filesInput).then(
      (data) => data.presignBlobs?.blobs,
    );
  };
}
